
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { default as __Next_Translate_old_getServerSideProps__1a06c87eef8__ } from '@utils/serverSide/getBasicServerSideProps';
import Cgv from '@screens/LegalDocumentation/Cgv';
export {} from '@utils/serverSide/getBasicServerSideProps';
export default Cgv;

    async function __Next_Translate__getServerSideProps__1a06c87eef8__(ctx) {
      const res = await __Next_Translate_old_getServerSideProps__1a06c87eef8__(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/cgv',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a06c87eef8__ as getServerSideProps }
  